export default "__VITE_ASSET__CR6GAUz7__"